import React, {useRef, useState} from "react"
import {Form, Button, Card, Alert} from "react-bootstrap"
import {useAuth} from "../contexts/AuthContext"
import leadtubLogoBlack from '../assets/logo/leadtubLogoBlack.png'
import {Link} from "react-router-dom"
import {Container} from "react-bootstrap"

export default function ForgotPassword() {


    const emailRef = useRef()
    const {resetPassword} = useAuth()
    const [error, setError] = useState("")
    const [message, setMessage] = useState("")
    const [loading, setLoading] = useState(false)

    async function handleSubmit(e) {
        e.preventDefault()

        try {
            setMessage("")
            setError("")
            setLoading(true)
            await resetPassword(emailRef.current.value)
            setMessage("Kontrollera din inbox!")

        } catch {
            setError("Failed to reset password")
        }

        setLoading(false)
    }

    return (
        <Container
            className="d-flex align-items-center justify-content-center"
            style={{minHeight: "100vh", minWidth: '100%', backgroundColor: '#414141'}}
        >
            <Card>
                <Card.Body>
                    <img style={{
                        display: 'block',
                        marginLeft: "auto",
                        marginRight: "auto"
                    }}
                         alt="Logo" className="text-center mb-4" src={leadtubLogoBlack}/>
                    <h2 className="text-center mb-4">Återställ ditt lösenord</h2>
                    <h4>
                        Fyll i din e-postadress som är kopplat till ditt <br/> Leadtub konto nedan.
                        <br/>
                        Du kommer sedan få ett mejl med instruktioner om <br/> hur du återställer ditt lösenord.
                    </h4>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {message && <Alert variant="success">{message}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group id="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" ref={emailRef} required placeholder={"Example@företag.se"}/>
                        </Form.Group>
                        <Button disabled={loading} className="w-100" type="submit">
                            Återställ lösenord
                        </Button>
                    </Form>
                    <div className="w-100 text-center mt-3">
                        <Link to="/login">Logga in</Link>
                    </div>
                </Card.Body>
            </Card>

        </Container>
    )
}
